import { Component, OnInit, Input } from '@angular/core'
import { DiagramData } from '../../models/diagram-data'
import { DiagramService } from '../../services/diagram.service'

@Component({
  selector: 'jml-lib-diagram',
  templateUrl: './diagram.component.html',
  styleUrls: ['./diagram.component.scss']
})
export class DiagramComponent implements OnInit {
  @Input() showPanel = true
  @Input() diagramData: DiagramData
  @Input() height: string

  constructor() {}

  ngOnInit() {}
}
